import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard {
  constructor(
    private readonly authService: AuthService
  ) { }

  public canActivate(): Observable<boolean> {
    return this.checkAuth();
  }

  public canActivateChild(): Observable<boolean> {
    return this.checkAuth();
  }

  private checkAuth(): Observable<boolean> {
    if (this.authService.isLoggedIn()) {
      return of(true);
    }
    if (!this.authService.isInteractionInProgress()) {
      this.authService.login();
    }
    return of(false);
  }
}
